import { useContext } from "react";
import { CalendarContext } from "./CalendarContextProvider";

const useCalendarContext = () => useContext(CalendarContext);

export default useCalendarContext;
